export default "__VITE_ASSET__BDZBBQtb__"